import { render, staticRenderFns } from "./TeamCreationSection.vue?vue&type=template&id=7174a0b4&scoped=true"
import script from "./TeamCreationSection.vue?vue&type=script&lang=js"
export * from "./TeamCreationSection.vue?vue&type=script&lang=js"
import style0 from "./TeamCreationSection.vue?vue&type=style&index=0&id=7174a0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7174a0b4",
  null
  
)

export default component.exports